/* Anya Johnson theme — AJAX cart drawer.
   Intercepts any form carrying [data-aj-ajax-cart-form] and adds via the Shopify
   AJAX Cart API instead of a full page reload. Falls back to a normal POST
   (and the browser's default redirect to /cart) if fetch/JS is unavailable. */
(function () {
  "use strict";

  var money = function (cents) {
    return (cents / 100).toFixed(2);
  };

  var drawer = document.querySelector("[data-aj-cart-drawer]");
  var backdrop = document.querySelector("[data-aj-cart-backdrop]");
  var body = document.querySelector("[data-aj-cart-body]");
  var foot = document.querySelector("[data-aj-cart-foot]");
  var subtotalEl = document.querySelector("[data-aj-cart-subtotal]");
  var countEls = document.querySelectorAll("[data-aj-cart-count]");
  if (!drawer || !backdrop || !body) return;

  function openDrawer() {
    drawer.classList.add("is-open");
    backdrop.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }

  function closeDrawer() {
    drawer.classList.remove("is-open");
    backdrop.classList.remove("is-open");
    document.body.style.overflow = "";
  }

  function renderItem(item) {
    var wrap = document.createElement("div");
    wrap.className = "aj-cart-item";
    wrap.innerHTML =
      '<div class="aj-cart-item-img">' +
        (item.image ? '<img src="' + item.image + '" alt="' + (item.product_title || "").replace(/"/g, "&quot;") + '">' : "") +
      "</div>" +
      '<div class="aj-cart-item-body">' +
        '<div class="aj-cart-item-title">' + item.product_title + "</div>" +
        (item.variant_title ? '<div class="aj-cart-item-variant">' + item.variant_title + "</div>" : "") +
        '<div class="aj-cart-item-row">' +
          '<div class="aj-cart-qty">' +
            '<button type="button" data-aj-qty-down aria-label="Decrease quantity">&minus;</button>' +
            "<span>" + item.quantity + "</span>" +
            '<button type="button" data-aj-qty-up aria-label="Increase quantity">+</button>' +
          "</div>" +
          '<div class="aj-cart-item-price">$' + money(item.final_line_price) + "</div>" +
        "</div>" +
        '<button type="button" class="aj-cart-item-remove" data-aj-remove>Remove</button>' +
      "</div>";

    wrap.querySelector("[data-aj-qty-up]").addEventListener("click", function () {
      changeLine(item.key, item.quantity + 1);
    });
    wrap.querySelector("[data-aj-qty-down]").addEventListener("click", function () {
      changeLine(item.key, Math.max(0, item.quantity - 1));
    });
    wrap.querySelector("[data-aj-remove]").addEventListener("click", function () {
      changeLine(item.key, 0);
    });
    return wrap;
  }

  function renderCart(cart) {
    countEls.forEach(function (el) { el.textContent = cart.item_count; });
    countEls.forEach(function (el) { el.classList.toggle("is-empty", cart.item_count === 0); });

    if (!cart.items.length) {
      body.innerHTML = '<div class="aj-cart-empty">Your cart is empty — the guides are waiting.</div>';
      foot.style.display = "none";
      return;
    }

    body.innerHTML = "";
    cart.items.forEach(function (item) { body.appendChild(renderItem(item)); });
    foot.style.display = "block";
    subtotalEl.textContent = "$" + money(cart.total_price);
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(renderCart);
  }

  function changeLine(key, quantity) {
    body.style.opacity = "0.5";
    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        body.style.opacity = "";
        renderCart(cart);
      })
      .catch(function () { body.style.opacity = ""; });
  }

  function addToCart(form) {
    var formData = new FormData(form);
    var submitBtn = form.querySelector('[type="submit"]');
    var originalLabel = submitBtn ? submitBtn.textContent : "";
    if (submitBtn) { submitBtn.disabled = true; submitBtn.textContent = "Adding…"; }

    fetch("/cart/add.js", {
      method: "POST",
      headers: { Accept: "application/json" },
      body: formData
    })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (err) { throw err; });
        return r.json();
      })
      .then(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
        fetchCart().then(openDrawer);
      })
      .catch(function () {
        if (submitBtn) { submitBtn.disabled = false; submitBtn.textContent = originalLabel; }
        form.submit();
      });
  }

  document.addEventListener("submit", function (e) {
    var form = e.target.closest("[data-aj-ajax-cart-form]");
    if (!form) return;
    e.preventDefault();
    addToCart(form);
  });

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-aj-cart-toggle]")) {
      e.preventDefault();
      fetchCart();
      openDrawer();
    }
    if (e.target.closest("[data-aj-cart-close]") || e.target === backdrop) {
      closeDrawer();
    }
  });

  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape") closeDrawer();
  });

  fetchCart();
})();
